import {gql} from '@apollo/client';

export const GENERATIVE_MODEL_RUNS_QUERY = gql`
  query GenerativeModelRunsQuery($proteinId: StrictString, $moleculeId: StrictString)
  @skipAudit
  @engComponent(name: MODEL_HUB) {
    generativeModelRuns(proteinId: $proteinId, moleculeId: $moleculeId) {
      id
      status
      createdAt
      zippedFullResultsFile {
        redirectUrl
      }
      topPredictedStructureFile {
        redirectUrl
      }
    }
  }
`;
